import React from 'react';
import {DocumentHistoryMainView} from "./DocumentHistoryMainView";
import {DocumentHistoryContextProvider} from "./DocumentHistoryContextProvider";

export const DocumentHistory = () => {
    return (
        <DocumentHistoryContextProvider>
            <DocumentHistoryMainView/>
        </DocumentHistoryContextProvider>
    );
}
